import React from 'react';
import { deviceMetrics, comparedTextToPeriod } from '../../constants/deviceMetrics';
import { NO_INFORMATION_AVAILABLE } from '../../constants';
import { formatDelta } from '../../utils/delta';
import { deviceMetricsColors } from '../../constants/deviceMetrics';
import DeltaIconUp from '../common/Icons/DeltaIconUp';
import DeltaIconDown from '../common/Icons/DeltaIconDown';
import DeltaIconNeutral from '../common/Icons/DeltaIconNeutral';

/**
 * CardV2 Component
 *
 * A reusable, clickable card component that displays an icon, title, description,
 * main metric, and optional details. It navigates to a specified URL on click and
 * supports additional custom styling via the `className` prop.
 *
 * Props:
 * - icon: React component to render as the card's icon.
 * - title: Card title text.
 * - copy: Descriptive text below the title.
 * - url: URL for navigation when the card is clicked.
 * - mainMetric: Prominent metric value.
 * - details: Optional additional details (string or React node).
 * - className: Optional custom class names for additional styling.
 */
const CardV2 = ({
  className = '',
  cardError = false,
  value,
  formatted,
  name,
  delta,
  handleClickCard,
  mode,
  metricSelected,
}) => {
  const deltaFormatted = formatDelta(delta, 2);

  return (
    <div
      onClick={() => handleClickCard(name)}
      className={`group relative bg-white text-left rounded-3xl p-8 shadow-sm flex flex-col gap-3 w-full w-[320px] min-h-[220px]
      transform transition-all duration-200 ease-out
      hover:scale-105 hover:shadow-lg flex justify-between flex-col
      ${metricSelected === name ? 'border' : ''} 
      ${className}`}
      style={metricSelected === name ? { borderColor: deviceMetricsColors[name] } : undefined}
    >
      <div className="flex items-center gap-2">
        <h2 className="text-black font-bold text-2xl">{deviceMetrics[name]}</h2>
      </div>
      {cardError ? (
        <p className="text-sm font-medium text-gray-500 mt-6">{NO_INFORMATION_AVAILABLE}</p>
      ) : (
        <div className="flex justify-between flex-col">
          {/**  Metric  */}
          <p className="text-[35px] font-medium text-[#000] mt-10">{formatted ?? value}</p>

          {/**  Comparition  */}
          {deltaFormatted && (
            <div className="flex items-center gap-2">
              {deltaFormatted.sign === 'neutral' ? (
                <DeltaIconNeutral color={deviceMetricsColors[name]} />
              ) : deltaFormatted.sign === 'positive' ? (
                <DeltaIconUp color={deviceMetricsColors[name]} />
              ) : (
                <DeltaIconDown color={deviceMetricsColors[name]} />
              )}
              {deltaFormatted.formatted && (
                <p
                  style={{ color: deviceMetricsColors[name] }}
                  className={`text-sm font-bold !text-[${deviceMetricsColors[name]}]`}
                >
                  {deltaFormatted.formatted} {comparedTextToPeriod[mode]}
                </p>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CardV2;
